import Modal from "@/components/modal/modal.vue";
import CalendarInput from "@/components/calendarInput/calendarInput.vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
import store from "@/store";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	props: {
		label: {
			type: Object,

			/*
			 * fields:
			 *	- label_id
			 *	- translations
			 *  - start_date (Optional, used when editing already tracked label)
			 *  - end_date (Optional, used when editing already tracked label)
			 */
		},
		type: {
			type: String,
			validator: function (value) {
				return ["add", "remove"].includes(value);
			},
		},
	},

	components: {
		Modal,
		CalendarInput,
	},

	data() {
		return {
			date:
				this.type === "add" && this.label.start_date
					? this.label.start_date.toDate()
					: moment.min(moment(), moment(store.getters["user/activeOutlet"].outlet_end_date)).toDate(),
		};
	},

	computed: {
		...userGetters(["activeOutlet"]),
		minDate,
		maxDate,
	},

	methods: { handleSave },
};

function handleSave() {
	this.$emit("save", this.label.label_id, this.date);
	this.$emit("close");
}

function minDate() {
	const outletStart = this.$moment(this.activeOutlet.outlet_start_date),
		// in case an item is removed, the end date has to be after the tracking start date
		min_ =
			this.type === "remove" && this.label.start_date ? moment.max(outletStart, this.label.start_date) : outletStart;
	return min_.toDate();
}

function maxDate() {
	const outletEnd = this.$moment(this.activeOutlet.outlet_end_date),
		// in case the start date is edited, it has to be before the tracking end date
		max_ = this.type === "add" && this.label.end_date ? moment.min(outletEnd, this.label.end_date) : outletEnd;
	return max_.toDate();
}
